module.exports = __webpack_public_path__ + "img/thumb_04.c259ce9e.jpg";